var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Location } from '../location/Location';
import { PathStore } from './modules/PathStore';
import { object } from '../../../utils/serializr/schema/object';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { withInit } from '../../../utils/serializr/schema/middle/withInit';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { UTCdate } from '../../../utils/serializr/schema/inner/UTCdate';
import { PathChildren } from './modules/PathChildren';
export class Path extends Location {
    type = 'path';
    isDatabaseEntity = true;
    orderposition = '';
    count = 0;
    app_count = 0;
    activity = 0;
    average = 0.66;
    depreciated = 0;
    voc_questions = 0;
    lastUpdate;
    pathStore;
    constructor(init) {
        super(init);
        editObservable(this);
    }
    get packages() {
        return '';
    }
    set packages(p) { }
    get bundles() {
        return '';
    }
    set bundles(p) { }
    get bundleNames() {
        return '';
    }
    set bundleNames(p) { }
    get pathChildren() {
        return new PathChildren(this);
    }
    static get serializeInfo() {
        return {
            extends: Location.serializeInfo,
            props: {
                orderposition: true,
                count: true,
                app_count: true,
                activity: true,
                average: true,
                depreciated: true,
                voc_questions: true,
                lastUpdate: UTCdate(),
                pathStore: withInit(object(PathStore), {}),
            },
        };
    }
}
__decorate([
    editable()
], Path.prototype, "orderposition", void 0);
__decorate([
    editable()
], Path.prototype, "count", void 0);
__decorate([
    editable()
], Path.prototype, "app_count", void 0);
__decorate([
    editable()
], Path.prototype, "depreciated", void 0);
__decorate([
    editable('ref')
], Path.prototype, "lastUpdate", void 0);
__decorate([
    memoize
], Path.prototype, "pathChildren", null);
__decorate([
    memoize
], Path, "serializeInfo", null);
